import { IIcon } from '~/components/ui/Icon'

export default function ArrowRight({ size, color }: Pick<IIcon, 'size' | 'color'>) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24'>
      {/* Icon from Solar by 480 Design - https://creativecommons.org/licenses/by/4.0/ */}
      <path
        fill={color}
        fillRule='evenodd'
        d='M13.47 5.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 1 1-1.06-1.06l4.72-4.72H4a.75.75 0 0 1 0-1.5h14.19l-4.72-4.72a.75.75 0 0 1 0-1.06'
        clipRule='evenodd'
      />
    </svg>
  )
}
